
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

// Safely access environment variables
const getEnv = (key: string) => {
  try {
    // @ts-ignore
    return (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env[key] : undefined;
  } catch (e) {
    return undefined;
  }
};

const BIRDEYE_API_KEY = getEnv('VITE_BIRDEYE_API_KEY');

export interface OHLCV {
    o: number;
    h: number;
    l: number;
    c: number;
    v: number;
    time: number;
}

/**
 * Fetches OHLCV data for a token
 */
export const getBirdeyeHistory = async (address: string, resolution = '15m'): Promise<OHLCV[]> => {
    // Try Real API
    if (BIRDEYE_API_KEY) {
        try {
            const response = await fetch(`https://public-api.birdeye.so/defi/ohlcv?address=${address}&type=${resolution}`, {
                headers: { 'X-API-KEY': BIRDEYE_API_KEY }
            });
            const data = await response.json();
            if (data.success && data.data?.items) {
                 return data.data.items.map((item: any) => ({
                     o: item.o,
                     h: item.h,
                     l: item.l,
                     c: item.c,
                     v: item.v,
                     time: item.unixTime
                 }));
            }
        } catch (e) {
            console.error("Birdeye Fetch Error:", e);
        }
    }

    // Generate mock candlestick data (fallback)
    const candles: OHLCV[] = [];
    let currentPrice = address.startsWith('So1') ? 145 : 10.0;
    const now = Math.floor(Date.now() / 1000);
    const interval = resolution === '1H' ? 3600 : 900; 

    for (let i = 50; i >= 0; i--) {
        const time = now - (i * interval);
        const volatility = currentPrice * 0.02;
        const open = currentPrice;
        const change = (Math.random() * volatility) - (volatility / 2);
        const close = open + change;
        const high = Math.max(open, close) + (Math.random() * volatility * 0.5);
        const low = Math.min(open, close) - (Math.random() * volatility * 0.5);
        const volume = Math.random() * 100000 * (currentPrice > 100 ? 0.1 : 10);

        candles.push({ o: open, h: high, l: low, c: close, v: volume, time });
        currentPrice = close;
    }

    return candles;
};
